import * as yup from 'yup';

yup.addMethod(yup.string, 'select', function () {
  return this.test('select', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && field.value) {
        resolve(true);
      } else {
        reject(
          createError({ path, message: 'field is required', type: 'required' })
        );
      }
    });
  });
});

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .trim(),
  macroDepartment: yup
    .string()
    .required()
    .trim(),
  description: yup
    .string()
    .required()
    .trim(),
  company: yup.string().select()
});

export default schema;
